// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout_Content__2ZjSY","modal_bg":"Layout_modal_bg__3vfwj","cardLink":"Layout_cardLink__1n1u1"};